
// export const backendLink = process.env.backend || 'http://192.168.1.8:3000'
export const backendLink = 'https://resail.vercel.app'